module.exports = __webpack_public_path__ + "img/first-0-opened.3f814ebd.webp";